import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import type { ReactNode } from "react";

interface TableChartCardProps {
	title: string;
	chart: ReactNode;
	table: ReactNode;
	analytics?: ReactNode;
}

export function TableChartCard({
	title,
	chart,
	table,
	analytics,
}: TableChartCardProps) {
	return (
		<Card>
			<Tabs defaultValue="chart" className="w-full">
				<CardHeader className="flex flex-row justify-between items-center space-y-0 px-4 py-2">
					<CardTitle className="">{title}</CardTitle>
					<TabsList className="">
						<TabsTrigger value="chart" className="h-7">
							Chart
						</TabsTrigger>
						<TabsTrigger value="table" className="h-7">
							Table
						</TabsTrigger>
					</TabsList>
				</CardHeader>
				<CardContent className="px-4 py-2">
					<TabsContent value="chart" className="mt-0">
						{chart}
					</TabsContent>
					<TabsContent value="table" className="mt-0">
						{table}
					</TabsContent>
					{analytics && <div className="mt-4">{analytics}</div>}
				</CardContent>
			</Tabs>
		</Card>
	);
}
